import React from "react";
import { Wrench } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-aegeanDeep text-white/85 pt-16 pb-8"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-brand-terracotta text-white">
              <Wrench size={18} strokeWidth={2.4} />
            </span>
            <span className="font-display text-xl font-semibold tracking-tight text-white">
              Christian's<span className="text-brand-terracotta">.</span>
              <span className="text-white/70 font-medium"> Multiservice</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-white/60">
            {t("footer.areas")}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Torrevieja</li>
            <li>Orihuela Costa</li>
            <li>Guardamar del Segura</li>
            <li>La Marina · San Miguel</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm uppercase tracking-widest text-white/60">
            {t("footer.contact")}
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                data-testid="footer-phone-link"
                href="tel:+34645602028"
                className="hover:text-brand-terracotta transition-colors font-medium"
              >
                +34 645 602 028
              </a>
            </li>
            <li>
              <a
                data-testid="footer-contact-link"
                href="#contact"
                className="hover:text-brand-terracotta transition-colors"
              >
                {t("nav.cta")}
              </a>
            </li>
            <li className="text-white/70">Deutsch · Español · English</li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/50">
        <div>© {new Date().getFullYear()} Christian's Multiservice · {t("footer.rights")}</div>
        <div>Costa Blanca Sur · España</div>
      </div>
    </footer>
  );
}
